module.exports = __webpack_public_path__ + "static/flags/JU-5166bcbea243043c2083eab7794b5870.gif";